let API_URL;
let AUTH_URL;
let BASE_URL;
let BACKGROUND_URL;
if (process.env.NODE_ENV !== 'development') {
  // API_URL = 'http://esduty.easysmart.cn/api'
  // AUTH_URL = 'http://esdutyauth.easysmart.cn'
  // BASE_URL = 'http://esduty.easysmart.cn'
  // BACKGROUND_URL = 'http://esduty.easysmart.cn/uploads/'
  API_URL = 'https://zyk.easysmart.cn/api';
  AUTH_URL = 'https://zyk.easysmart.cn/auth';
  BASE_URL = 'https://zyk.easysmart.cn';
  BACKGROUND_URL = 'https://zyk.easysmart.cn/api/uploads/';
  // API_URL = 'http://larb.hep.com.cn/api';
  // AUTH_URL = 'http://larb.hep.com.cn/auth';
  // BASE_URL = 'http://larb.hep.com.cn';
  // BACKGROUND_URL = 'http://larb.hep.com.cn/uploads/';
} else {
  API_URL = 'http://192.168.199.160:5001/api';
  AUTH_URL = 'http://192.168.199.160:5000';
  BACKGROUND_URL = 'http://192.168.199.160:5001/uploads/';
  BASE_URL = 'http://192.168.199.160';
  // API_URL = 'http://192.168.199.160:5001/api'
  // AUTH_URL = 'http://192.168.199.160:5000'
  // BACKGROUND_URL = 'http://192.168.199.160:5001/uploads/'
  // BASE_URL = 'http://beardidi.xicp.net'
}
export default {
  API_URL,
  AUTH_URL,
  BASE_URL,
  BACKGROUND_URL,
  getToken: function() {
    let token = window.localStorage[(window as any).mgr._userStore._prefix + (window as any).mgr._userStoreKey];
    if (token == null) {
      window.localStorage['ESResource_RedirectURL'] = window.location.href;
      token = '{"profile": {"role": "Role0"}}';
      // (window as any).mgr.signinRedirect();
      // console.log('redirect')
    }
    return JSON.parse(token);
  },
  getAccessToken: function() {
    return this.getToken().access_token;
  },
  getUserId: function() {
    return this.getToken().profile.sub;
  },
  getUserType: function() {
    let result = this.getToken().profile.role;
    if (result === undefined || result === '') {
      result = 'Role0';
    }
    result = result.replace('Role', '');
    return result ? parseInt(result, 10) : 0;
  },
  getRole: function() {
    const result = this.getToken().profile.role;
    return result;
  },
  getRealName: function() {
    const result = this.getToken().profile.RealName;
    return result;
  },
  IsAdmin: function() {
    const role = this.getRole();
    return role && role === 'admin';
  },
};

